import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header-text" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "spinner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phone_number_selector = _resolveComponent("phone-number-selector")!
  const _component_voucher_card = _resolveComponent("voucher-card")!
  const _component_spinner_component = _resolveComponent("spinner-component")!
  const _component_voucher_success_card = _resolveComponent("voucher-success-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.isRedeemVoucher ? 'processEvent.voucher.header' : 'processEvent.buy.header')), 1),
    (!_ctx.isRedeemVoucherDone)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.next()), ["prevent"]))
        }, [
          _createVNode(_component_phone_number_selector, {
            selectedCountry: _ctx.country,
            phoneNumber: _ctx.phoneNumber,
            "onUpdate:selectedCountry": _ctx.selectCountry,
            "onUpdate:phoneNumber": _ctx.changePhoneNumber,
            invalid: _ctx.invalidPhonenumber
          }, null, 8, ["selectedCountry", "phoneNumber", "onUpdate:selectedCountry", "onUpdate:phoneNumber", "invalid"]),
          _createVNode(_component_voucher_card, {
            expanded: _ctx.isRedeemVoucher,
            invalid: _ctx.invalidVoucherCode,
            modelValue: _ctx.voucherCode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.voucherCode) = $event))
          }, null, 8, ["expanded", "invalid", "modelValue"]),
          (_ctx.isRedeemVoucher || (_ctx.packs === null && !_ctx.isPhonePrefilled))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "submit-phonenumber",
                disabled: (_ctx.isRedeemVoucher && _ctx.processLoading) || _ctx.isLoading
              }, [
                (!(_ctx.isRedeemVoucher && _ctx.processLoading))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('next')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_4, [
                  ((_ctx.isRedeemVoucher && _ctx.processLoading) || _ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_spinner_component, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "secondary-btn",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeProcessEvent()))
          }, _toDisplayString(_ctx.$t(_ctx.isRedeemVoucher ? 'processEvent.buy.subtext' : 'processEvent.voucher.subtext')), 1)
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.isRedeemVoucher && _ctx.isRedeemVoucherDone)
      ? (_openBlock(), _createBlock(_component_voucher_success_card, {
          key: 1,
          isSuccess: _ctx.redeemStatus,
          onShowVoucher: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isRedeemVoucherDone = false)),
          phoneNumber: _ctx.fullPhoneNumber,
          voucherSuccess: _ctx.voucherResponse
        }, null, 8, ["isSuccess", "phoneNumber", "voucherSuccess"]))
      : _createCommentVNode("", true)
  ], 64))
}